import { useCallback, useEffect, useState } from "react";
import type { FollowUpList } from "../shared/followup";
import { api } from "./api";

/** Fired after «✓ Έγινε» or a snooze so the sidebar badge refreshes. */
export const FOLLOW_UPS_CHANGED = "caterflow:followups-changed";

export function useFollowUps(enabled: boolean): { list: FollowUpList | null; error: string | null; reload: () => void } {
  const [list, setList] = useState<FollowUpList | null>(null);
  const [error, setError] = useState<string | null>(null);
  const reload = useCallback(() => {
    if (!enabled) return;
    api<FollowUpList>("/api/followups")
      .then((value) => {
        setList(value);
        setError(null);
      })
      .catch((reason: unknown) => setError(reason instanceof Error ? reason.message : "Τα follow-up δεν φόρτωσαν."));
  }, [enabled]);
  useEffect(() => {
    reload();
    const onChange = () => reload();
    window.addEventListener(FOLLOW_UPS_CHANGED, onChange);
    return () => window.removeEventListener(FOLLOW_UPS_CHANGED, onChange);
  }, [reload]);
  return { list, error, reload };
}

export function followUpsChanged(): void {
  window.dispatchEvent(new Event(FOLLOW_UPS_CHANGED));
}
